import { getImage } from "gatsby-plugin-image";
import React from "react";
import { IWPImage } from "./types";
import NewWindowIcon from "@/assets/new-window.svg";
import MailIcon from "@/assets/mail.svg";
import PhoneIcon from "@/assets/phone.svg";
import FacetimeIcon from "@/assets/facetime.svg";
import PrintIcon from "@/assets/print.svg";
import UploadIcon from "@/assets/upload.svg";

export const nlToBr = (text: string) =>
  (text || "").split("\n").map((l, index) => (
    <React.Fragment key={index}>
      {l}
      <br />
    </React.Fragment>
  ));

export const toGatsbyImage = (image: IWPImage) => {
  const imageData = image?.localFile?.childImageSharp?.gatsbyImageData
    ? getImage(image.localFile.childImageSharp.gatsbyImageData)
    : null;
  return imageData;
};

export const renderIcon = (icon: string) => {
  switch (icon) {
    case "new-window":
      return <NewWindowIcon />;
    case "mail":
      return <MailIcon />;
    case "phone":
      return <PhoneIcon />;
    case "facetime":
      return <FacetimeIcon />;
    case "print":
      return <PrintIcon />;
    case "upload":
      return <UploadIcon />;
    default:
      return null;
  }
};

export const getBgColor = (type: string, color: string) => {
  if (type === "light") {
    switch (color) {
      case "purple":
        return "#D4D2E4";
      case "pink":
        return "#FBD8EE";
      case "green":
        return "#E9F6EF";
      case "blue":
        return "#DCF3FB";
      default:
        return "white";
    }
  } else {
    switch (color) {
      case "purple":
        return "#534B93";
      case "pink":
        return "#F49DD5";
      case "green":
        return "#51D996";
      case "blue":
        return "#71CFF0";
      case "standard":
        return "#281E78";
      default:
        return "#281E78";
    }
  }
};

// translate to english (wp uses swedish color names)
export const translateColor = (tagColor: string) => {
  const colorTranslations: { [key: string]: string } = {
    Blå: "purple",
    Rosa: "pink",
    Grön: "green",
    Turkos: "blue",
  };

  return colorTranslations[tagColor] || tagColor;
};

export const formatDate = (dateStr: string, displayYear: boolean) => {
  const [day, month, year] = dateStr.split("/");
  const monthNames = [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december",
  ];
  return `${parseInt(day, 10)} ${monthNames[parseInt(month, 10) - 1]} ${displayYear ? year : ""}`;
};

export const parseDate = (dateString: string) => {
  const [day, month, year] = dateString.split("/");
  return new Date(`${year}-${month}-${day}`);
};
